import React from "react";
import { L10nHtml } from "../i18n";
import { UserProfile } from "../models/userProfile";
import { UserPresenter } from "../utils/userPresenter";
import { Avatar } from "./avatar/avatar";
import styles from "./typing.css";

interface Props {
  users: Array<UserProfile>;
  widgetStyle?: boolean;
}

export const TypingComponent = (props: Props) => {
  return (
    <div
      className={[styles.typing, props.widgetStyle ? styles.widget : styles.dashboard].join(" ")}
    >
      <div className={styles.avatars}>
        {props.users.slice(0, 3).map((user) => (
          <div className={styles["avatar-container"]} key={UserPresenter.from(user).displayedName}>
            <div className={styles.avatar}>
              <Avatar user={user} widgetStyle={props.widgetStyle} />
            </div>
          </div>
        ))}
      </div>
      <div className={styles.text}>
        <span>
          <L10nHtml id={"conversation.typing"} values={getTypingParams(props.users)} />
        </span>
      </div>
    </div>
  );
};

function getTypingParams(users: Array<UserProfile>): { [key: string]: string | number } {
  return users.slice(0, 3).reduce(
    (result, user, i) => ({
      ...result,
      [`user${i + 1}`]: user.firstName || UserPresenter.from(user).displayedName
    }),
    { count: users.length }
  );
}
